"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { Image } from "@shared/ui/image";
import { InViewVideo } from "@shared/ui/video/video";

import type { BackgroundMediaBase } from "./model";

import s from "./background-media.module.scss";

export type BackgroundMediaProps = ComponentProps<"div"> &
  BackgroundMediaBase & {
    className?: string;
    wrapperClassName?: string;
  };

export const BackgroundMedia = (props: BackgroundMediaProps) => {
  const {
    className,
    wrapperClassName,
    type,
    image,
    video,
    children,
    ...restProps
  } = props;

  const renderContent = () => {
    if (type === "video" && video?.url) {
      return (
        <InViewVideo
          src={video.url}
          className={clsx(s.media, className)}
          loop
          muted
          playsInline
        />
      );
    }

    if (image?.url) {
      return (
        <Image
          src={image.url}
          alt={image?.alternativeText ?? "Background"}
          className={clsx(s.media, className)}
          objectFit="cover"
          height="100%"
          width="100%"
          fetchPriority="high"
        />
      );
    }

    return children || null;
  };

  return (
    <div className={clsx(s.root, wrapperClassName)} {...restProps}>
      <div className={s.content}>{renderContent()}</div>
    </div>
  );
};

BackgroundMedia.displayName = "BackgroundMedia";
